import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, ShieldCheck, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function AdminLogin() {
  const navigate = useNavigate();

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#07301f] relative overflow-hidden flex items-center justify-center p-6">
      <div className="absolute inset-0 hero-grid-bg opacity-40" />
      <div className="absolute top-20 right-20 w-[500px] h-[500px] bg-[#0a4a31] rounded-full blur-[120px] opacity-40" />

      <button
        onClick={() => navigate('/')}
        className="absolute top-6 left-6 inline-flex items-center gap-2 text-white/70 hover:text-white text-sm"
      >
        <ArrowLeft className="w-4 h-4" /> Volver al sitio
      </button>

      <div className="relative bg-white rounded-2xl p-10 max-w-md w-full shadow-2xl">
        <div className="w-14 h-14 rounded-full bg-[#07301f] text-white flex items-center justify-center mx-auto mb-6">
          <ShieldCheck className="w-7 h-7" strokeWidth={1.75} />
        </div>
        <div className="text-center mb-8">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#07301f]/70 font-medium mb-3">
            Panel de Administración
          </div>
          <h1 className="text-3xl font-bold tracking-tight mb-3">Iniciar sesión</h1>
          <p className="text-neutral-600 text-sm">
            Acceso restringido. Solo correos autorizados pueden acceder al panel.
          </p>
        </div>

        <Button
          onClick={handleLogin}
          className="w-full h-12 bg-[#07301f] hover:bg-[#0a4a31] text-white rounded-md font-medium text-sm"
        >
          <LogIn className="w-4 h-4 mr-2" />
          Continuar con Google
        </Button>

        <p className="text-center text-xs text-neutral-500 mt-6">
          Email autorizado: <span className="font-medium text-[#07301f]">patagonialobby@gmail.com</span>
        </p>
      </div>
    </div>
  );
}
